(function () {
  'use strict';

  if (window.UnifiedValidator) {
    return;
  }

  const VERSION = '1.1.0';

  function getSchema() {
    return window.UnifiedSchema || null;
  }

  function clone(value) {
    if (
      value === null ||
      typeof value === 'undefined'
    ) {
      return value;
    }

    try {
      return JSON.parse(
        JSON.stringify(value)
      );
    } catch (error) {
      return value;
    }
  }

  function isEmpty(value) {
    return (
      value === '' ||
      value === null ||
      typeof value === 'undefined'
    );
  }

  function valueMatchesType(
    value,
    expectedType
  ) {
    if (expectedType === 'array') {
      return Array.isArray(value);
    }

    if (expectedType === 'object') {
      return (
        value !== null &&
        typeof value === 'object' &&
        !Array.isArray(value)
      );
    }

    return (
      typeof value ===
      expectedType
    );
  }

  function validateNumericRange(
    fieldName,
    value,
    definition,
    errors
  ) {
    if (
      typeof value !== 'number' ||
      !Number.isFinite(value)
    ) {
      return;
    }

    if (
      typeof definition.minimum ===
        'number' &&
      value < definition.minimum
    ) {
      errors.push({
        code:
          'value_below_minimum',

        field:
          fieldName,

        minimum:
          definition.minimum,

        received:
          value
      });
    }

    if (
      typeof definition.maximum ===
        'number' &&
      value > definition.maximum
    ) {
      errors.push({
        code:
          'value_above_maximum',

        field:
          fieldName,

        maximum:
          definition.maximum,

        received:
          value
      });
    }
  }

  function validateRequiredFields(
    eventName,
    payload,
    errors
  ) {
    const schema =
      getSchema();

    const requiredFields =
      schema.getRequiredFields(
        eventName
      );

    requiredFields.forEach(
      function (fieldName) {
        if (
          isEmpty(
            payload[fieldName]
          )
        ) {
          errors.push({
            code:
              'required_field_missing',

            field:
              fieldName
          });
        }
      }
    );
  }

  function validateFieldTypes(
    eventName,
    payload,
    errors
  ) {
    const schema =
      getSchema();

    Object.keys(payload)
      .forEach(function (fieldName) {
        const value =
          payload[fieldName];

        if (isEmpty(value)) {
          return;
        }

        const definition =
          schema.getFieldDefinition(
            eventName,
            fieldName
          );

        if (!definition) {
          return;
        }

        if (
          !valueMatchesType(
            value,
            definition.type
          )
        ) {
          errors.push({
            code:
              'invalid_field_type',

            field:
              fieldName,

            expected:
              definition.type,

            received:
              Array.isArray(value)
                ? 'array'
                : typeof value
          });

          return;
        }

        validateNumericRange(
          fieldName,
          value,
          definition,
          errors
        );
      });
  }

  function findUnknownFields(
    eventName,
    payload
  ) {
    const schema =
      getSchema();

    const allowedFields =
      new Set(
        schema.getAllowedFields(
          eventName
        )
      );

    return Object.keys(payload)
      .filter(function (fieldName) {
        return (
          !allowedFields.has(
            fieldName
          )
        );
      });
  }

  function validate(
    eventName,
    payload
  ) {
    const schema =
      getSchema();

    const result = {
      valid: false,

      event:
        eventName || '',

      payload:
        clone(payload || {}),

      errors: [],

      warnings: [],

      validated_at:
        new Date().toISOString()
    };

    if (!schema) {
      result.errors.push({
        code:
          'schema_unavailable'
      });

      return result;
    }

    if (!eventName) {
      result.errors.push({
        code:
          'event_name_missing'
      });

      return result;
    }

    const eventSchema =
      schema.getEventSchema(
        eventName
      );

    if (!eventSchema) {
      result.errors.push({
        code:
          'event_schema_missing',

        event:
          eventName
      });

      return result;
    }

    validateRequiredFields(
      eventName,
      result.payload,
      result.errors
    );

    validateFieldTypes(
      eventName,
      result.payload,
      result.errors
    );

    const unknownFields =
      findUnknownFields(
        eventName,
        result.payload
      );

    unknownFields.forEach(
      function (fieldName) {
        result.warnings.push({
          code:
            'unknown_field',

          field:
            fieldName
        });
      }
    );

    result.valid =
      result.errors.length === 0;

    return result;
  }

  function printResult(result) {
    const source =
      result || {};

    if (source.valid) {
      console.info(
        '[Unified Validator] Event valid',
        {
          event:
            source.event,

          warnings:
            source.warnings
        }
      );

      return source;
    }

    console.error(
      '[Unified Validator] Event invalid',
      {
        event:
          source.event,

        errors:
          source.errors,

        warnings:
          source.warnings
      }
    );

    return source;
  }

  window.UnifiedValidator = {
    version: VERSION,

    validate: validate,

    printResult:
      printResult
  };

  if (
    window.UnifiedTrackingConfig &&
    window.UnifiedTrackingConfig.debug
  ) {
    console.info(
      '[Unified Validator] Schema Validator initialized',
      {
        version: VERSION,
        schema:
          window.UnifiedSchema
            ? 'available'
            : 'unavailable'
      }
    );
  }
})();